import { CommerceService } from "@/services/commerce"

/**
 * If triggered more than once (custom type exists, error will be returned)
 *
 * Kept here to track progress and for future migrations.
 * Purpose to add custom fields for customer cart and then store weight information
 *
 * https://docs.commercetools.com/api/projects/types#ctp:api:type:ResourceTypeId
 * Tthe Types for Carts are also valid for Orders, and hence both have the same identifier.
 */
export const mutationAddCustomCartType = {
  async addCustomCartType(parent, args, context, info) {
    const commerceApi = CommerceService.api()

    const typeDraft = {
      key: "customCartTypeKey",
      name: { "de-DE": "customCartTypeName", "en-US": "customCartTypeName" },
      description: {
        "de-DE": "Benutzerdefinierte Felder für den Warenkorb",
        "en-US": "Custom fields for cart",
      },
      resourceTypeIds: ["order"],
      fieldDefinitions: [
        {
          type: {
            name: "Money",
          },
          name: "freightSurcharge",
          label: {
            "de-DE": "Frachtkostenzuschlag",
            "en-US": "Freight surcharge",
          },
          required: false,
        },
      ],
    }

    try {
      await commerceApi.types().post({ body: typeDraft }).execute()

      return true
    } catch (error) {
      throw new Error(error)
    }
  },
}
